import React from 'react';
import PropTypes from 'prop-types';
import {Skeleton} from '@mui/material';
import {useGetFormEditHistoryQuery} from '../../../../api/services/formRequestsService';
import ResponseEditHistory from '../../../../shared-components/ResponseEditHistory';

// AD-2695: every edit to the form's submitted responses, newest first.
const FormEditHistory = ({formId}) => {
    const {data, isLoading} = useGetFormEditHistoryQuery(formId, {skip: !formId, refetchOnMountOrArgChange: true});

    if (isLoading) return <Skeleton variant="rounded" height={80}/>;

    return <ResponseEditHistory edits={data} emptyText="No responses have been edited."/>;
};

FormEditHistory.propTypes = {
    formId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default FormEditHistory;
